// extracted by mini-css-extract-plugin
export default {"priceDetails":"styles_priceDetails__VAbDU","price":"styles_price__MuXlp"};